import { useCallback } from 'react';

import { useSetState } from './use-set-state.js';

export const useSetHighlightedIdsState = () => {
  const setState = useSetState();

  const setHighlightedIdsState = useCallback(
    (ids: string[]) => {
      setState((prev) => {
        return {
          ...prev,
          highlightedIds: ids,
        };
      });
    },
    [setState],
  );

  return setHighlightedIdsState;
};
